import React, { useState } from 'react';
import { Dialog } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

interface ImageLightboxProps {
  children: React.ReactNode;
  ariaLabel?: string;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({
  children,
  ariaLabel,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="ImageLightbox__trigger"
        onClick={() => setIsOpen(true)}
        aria-label={ariaLabel}
        aria-expanded={isOpen}
      >
        {children}
      </button>

      <Dialog
        id="image-lightbox"
        isOpen={isOpen}
        closeFunction={() => setIsOpen(false)}
        showCloseIcon
        closeIcon="icon-cross icon-variant-1"
      >
        <div className="ImageLightbox__content">
          {children}
        </div>
      </Dialog>
    </>
  );
};

export default ImageLightbox;
